/* ==========================================================================
   Skogstad Sport – Kundeservice (navet)

   Seksjonen: sections/skogstad-kundeservice.liquid
   Stilene:   assets/skogstad-kundeservice.css

   Egen fil, ikke skogstad-globalt.js. Samme grunn som for CSS-en: dette er
   én side, og koden har ingenting å gjøre i en fil som lastes på hver
   sidevisning. Lastes med defer fra seksjonen selv.

   FILTRERER LENKER, IKKE KORT
   Butikksøket i «Finn butikk» skjuler kort. Her skjules enkeltlenkene, og en
   klynge skjules først når alle lenkene i den er borte. Grunnen er at
   klyngene er kategorier og ikke innhold: skriver kunden «retur», er svaret
   «Angrerett og retur» og «Bytte størrelse» – ikke «klyngen Retur, som
   inneholder noe du må lete videre i».

   Samme prinsipp ellers som butikksøket: alt ligger i DOM-en fra server,
   filtrering er å sette og fjerne ett attributt, ingen nettverkskall, ingen
   ventetilstand, ingen debounce. Tjue lenker med et attributt hver er under
   et millisekund.

   LYTTERNE ER DELEGERT FRA document
   Temaeditoren bygger seksjonen på nytt ved hver endring i innstillingene, og
   lyttere på enkeltnoder ville dødd med markupen de satt på.
   ========================================================================== */
(function () {
  'use strict';

  var SEKSJON = '[data-skogstad-kundeservice]';
  var FELT = '[data-ks-sok]';
  var KLYNGE = '[data-ks-klynge]';
  var LENKE = '[data-ks-lenke]';
  var TOMKNAPP = '[data-ks-tom]';
  var INGEN = '[data-ks-ingen]';
  var STATUS = '[data-ks-status]';

  /* ------------------------------------------------------------------------
     Folding av søketekst

     Identisk med skogstad-finn-butikk.js, og med vilje duplisert framfor
     løftet til en delt fil: de to sidene lastes aldri samtidig, og en delt
     fil ville betydd et ekstra kall på hver av dem for å spare tretti linjer.
     Endres den ene, skal den andre endres med – det er notert her og der.

     «Storrelse» skal finne «Størrelse», «angrefrist» skal finne
     «Angrerett». Kunden som lurer på returfristen skal ikke måtte finne
     Ø-tasten først, og hun skal ikke måtte skrive ordet slik vi valgte å
     skrive det.

     Foldinga kjøres på BEGGE sider av sammenligninga. Bare én side hadde
     gjort søket asymmetrisk – «størrelse» ville ikke funnet seg selv.
     ------------------------------------------------------------------------ */
  function fold(tekst) {
    var t = String(tekst || '')
      .toLowerCase()
      .replace(/æ/g, 'ae')
      .replace(/ø/g, 'o')
      .replace(/å/g, 'a');

    if (typeof t.normalize === 'function') {
      t = t.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    }

    return t.replace(/[.,\-/]+/g, ' ').replace(/\s+/g, ' ').trim();
  }

  /* ------------------------------------------------------------------------
     Søkeindeksen

     Bygget i Liquid (data-ks-tekst) og inneholder lenketittel, hjelpetekst og
     redaktørens egne søkeord. Søkeordene er der fordi kundens ord sjelden er
     våre: hun skriver «pengene tilbake», «bytte jakke», «angrefrist»,
     «vaskeanvisning» – vi skrev «Angrerett og retur» og «Vask og
     vedlikehold». Uten synonymfeltet er søket et søk i våre overskrifter.

     Foldes én gang per lenke og bufres på noden.
     ------------------------------------------------------------------------ */
  function lenkeTekst(lenke) {
    if (!lenke.__ksTekst) {
      lenke.__ksTekst = fold(lenke.getAttribute('data-ks-tekst') || lenke.textContent);
    }
    return lenke.__ksTekst;
  }

  /* ALLE ORDENE MÅ TREFFE, HVER FOR SEG. «retur penger» og «penger retur»
     gir samme treff. Kunden skriver det hun husker, i den rekkefølgen hun
     husker det. */
  function treffer(lenke, ord) {
    var tekst = lenkeTekst(lenke);
    for (var i = 0; i < ord.length; i++) {
      if (tekst.indexOf(ord[i]) === -1) return false;
    }
    return true;
  }

  function filtrer(seksjon) {
    var felt = seksjon.querySelector(FELT);
    if (!felt) return;

    var lenker = Array.prototype.slice.call(seksjon.querySelectorAll(LENKE));
    if (!lenker.length) return;

    var sok = fold(felt.value);
    var ord = sok ? sok.split(' ') : [];
    var antall = 0;

    for (var i = 0; i < lenker.length; i++) {
      var vis = ord.length === 0 || treffer(lenker[i], ord);
      /* `hidden` og ikke en klasse: attributtet fjerner elementet fra
         tilgjengelighetstreet, slik at skjermleseren ikke leser opp lenker
         kunden har filtrert bort. Settes på raden (li), ikke på anker-taggen
         – en skjult lenke inne i en synlig rad etterlater en tom strek. */
      if (vis) {
        lenker[i].removeAttribute('hidden');
        antall++;
      } else {
        lenker[i].setAttribute('hidden', '');
      }
    }

    /* En klynge uten synlige lenker er en overskrift over ingenting. Den
       skjules helt – inkludert tittelen og forklaringa, som ellers ville
       stått igjen og sett ut som et treff. */
    var klynger = seksjon.querySelectorAll(KLYNGE);
    for (var k = 0; k < klynger.length; k++) {
      var synlige = klynger[k].querySelectorAll(LENKE + ':not([hidden])');
      if (synlige.length) klynger[k].removeAttribute('hidden');
      else klynger[k].setAttribute('hidden', '');
    }

    var ingen = seksjon.querySelector(INGEN);
    if (ingen) {
      if (antall === 0) ingen.removeAttribute('hidden');
      else ingen.setAttribute('hidden', '');
    }

    var tomknapp = seksjon.querySelector(TOMKNAPP);
    if (tomknapp) {
      if (felt.value) tomknapp.removeAttribute('hidden');
      else tomknapp.setAttribute('hidden', '');
    }

    /* Treffteller for skjermlesere. Står søket tomt, tømmes den – da er lista
       ufiltrert, og «20 treff» er en opplesing ingen har bedt om.

       Strengene bor i markupen (data-en-treff / data-flere-treff), ikke her:
       all norsk tekst skal komme fra locales/nb.json via Liquid, aldri
       hardkodes i JavaScript. Plassholderen er «%n%», ikke {{ }} – Shopifys
       t-filter tolker de selv. */
    var status = seksjon.querySelector(STATUS);
    if (status) {
      if (ord.length === 0) {
        status.textContent = '';
      } else if (antall === 0) {
        status.textContent = status.getAttribute('data-ingen-treff') || '';
      } else {
        var mal = antall === 1
          ? status.getAttribute('data-en-treff')
          : status.getAttribute('data-flere-treff');
        status.textContent = (mal || '').replace('%n%', antall);
      }
    }
  }

  /* ------------------------------------------------------------------------
     Hendelser

     `input` og ikke `keyup`: input fanger også innliming med mus, diktering,
     autofyll og nettleserens egen tømmekryss. `search` i tillegg, for
     Safari, der tømmekrysset utløser `search` og ikke alltid `input`.
     ------------------------------------------------------------------------ */
  function seksjonenTil(node) {
    return node && node.closest ? node.closest(SEKSJON) : null;
  }

  function pastastFilter(evt) {
    if (!evt.target.matches || !evt.target.matches(FELT)) return;
    var seksjon = seksjonenTil(evt.target);
    if (seksjon) filtrer(seksjon);
  }

  document.addEventListener('input', pastastFilter);
  document.addEventListener('search', pastastFilter);

  document.addEventListener('click', function (evt) {
    var knapp = evt.target.closest ? evt.target.closest(TOMKNAPP) : null;
    if (!knapp) return;

    var seksjon = seksjonenTil(knapp);
    if (!seksjon) return;

    var felt = seksjon.querySelector(FELT);
    if (!felt) return;

    felt.value = '';
    filtrer(seksjon);
    /* Fokus tilbake i feltet. Knappen er nå skjult, og fokus på en skjult
       node faller til <body> – da har den som navigerer med tastatur mistet
       plassen sin. */
    felt.focus();
  });

  /* Escape tømmer feltet. Konvensjonen for et søkefelt. */
  document.addEventListener('keydown', function (evt) {
    if (evt.key !== 'Escape') return;
    if (!evt.target.matches || !evt.target.matches(FELT)) return;
    if (!evt.target.value) return;

    evt.target.value = '';
    var seksjon = seksjonenTil(evt.target);
    if (seksjon) filtrer(seksjon);
  });

  /* ------------------------------------------------------------------------
     Selvretting ved innlasting

     Nettleseren gjenoppretter verdien i søkefeltet når kunden kommer tilbake
     med tilbakeknappen. Uten dette ville feltet stått med «retur» og alle
     klyngene vist – en side som motsier seg selv.
     ------------------------------------------------------------------------ */
  function init() {
    var seksjoner = document.querySelectorAll(SEKSJON);
    for (var i = 0; i < seksjoner.length; i++) {
      var felt = seksjoner[i].querySelector(FELT);
      if (felt && felt.value) filtrer(seksjoner[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('pageshow', function (evt) {
    if (evt.persisted) init();
  });

  document.addEventListener('shopify:section:load', function (evt) {
    if (evt.target.querySelector && evt.target.querySelector(SEKSJON)) init();
  });

  /* Å velge en blokk i sidepanelet rendrer ikke seksjonen på nytt, så et
     aktivt søk står. Velger redaktøren en lenke som er filtrert bort, ruller
     editoren til en node med `hidden` – hun ser ingenting skje. Søket tømmes
     derfor ved blokkvalg: i editoren er lista et arbeidsverktøy, ikke et
     søkeresultat. */
  document.addEventListener('shopify:block:select', function (evt) {
    var seksjon = seksjonenTil(evt.target);
    if (!seksjon) return;

    var felt = seksjon.querySelector(FELT);
    if (!felt || !felt.value) return;

    felt.value = '';
    filtrer(seksjon);
  });
})();
